import PropTypes from 'prop-types'

import { Form, Input, Link, Button, Padding } from '../../..'
import { layerForm as layerFormProps } from '../../../../types'
import { colors } from '../../../../constants'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '../../../../reducers'
import { selectChainByID } from '../../../../reducers/chains'

const { Label } = Form

function PlaylistsForm({
    errors,
    isOpen,
    onChangeForm,
    onClickNullEndDate,
    onClickNullStartDate,
    onClickRemoveEndDate,
    onClickRemoveStartDate,
    onClickSubmit,
    selectedChainId,
    values,
}) {
    const { t } = useTranslation()

    const renderStartDateLabel = () => {
        return (
            <>
                {t('date-start')}
                &nbsp;
                <Link onClick={onClickRemoveStartDate} color="white">
                    &times;
                </Link>
            </>
        )
    }

    const renderEndDateLabel = () => {
        return (
            <>
                {t('date-end')}
                &nbsp;
                <Link onClick={onClickRemoveEndDate} color="white">
                    &times;
                </Link>
            </>
        )
    }

    const {
      name: errorName,
      date_start: errorDateStart,
      date_end: errorDateEnd,
    } = errors;
    const { name, date_start, date_end, chain_id, slug } = values;
    const {
      name: onChangeName,
      date_start: onChangeDateStart,
      date_end: onChangeDateEnd,
    } = onChangeForm;

    const selectedChain = useAppSelector(state => selectChainByID(state, chain_id)) ?? {}
    const hasWrongChainAssigned = selectedChain && selectedChainId !== selectedChain.id

    return (
      <div
      style={{
        textAlign: 'left',
        marginTop: isOpen && '10px',
        marginBottom: isOpen && '10px',
        paddingTop: '10px',
        paddingBottom: '10px',
        paddingLeft: '15px',
        borderTop: `1px ${colors.bluelight} solid`,
      }}
    >
      <Label label={t('Playlist Name')} error={errorName}>
      <Input
            name="name"
            type="text"
            error={!!errorName}
            onChange={onChangeName}
            size="md"
            value={name}
            borderColor={colors.bluedarkest}
            style={{ padding: '9px' }}
            onClick={e =>
              typeof e.stopPropagation === 'function' && e.stopPropagation()
            }
          />
        </Label>
        {date_start && isOpen && (
          <>
            <br />
            <Label label={renderStartDateLabel()} error={errorDateStart}>
            <Input
                name="date_start"
                type="date"
                error={!!errorDateStart}
                onChange={onChangeDateStart}
                value={date_start}
                borderColor={colors.bluedarkest}
                style={{ padding: '9px' }}
                withTime
                onClick={e =>
                  typeof e.stopPropagation === 'function' && e.stopPropagation()
                }
              />
            </Label>
          </>
        )}
        {!date_start && isOpen && (
          <div>
            <Link
                onClick={onClickNullStartDate}
                color={colors.bluelighter2}
                style={{ fontStyle: 'italic' }}
            >
              {t('date-start-add')}
            </Link>
          </div>
        )}
        {date_end && isOpen && (
          <>
            <br />
            <Label label={renderEndDateLabel()} error={errorDateEnd}>
            <Input
                name="date_end"
                type="date"
                error={!!errorDateEnd}
                onChange={onChangeDateEnd}
                value={date_end}
                borderColor={colors.bluedarkest}
                style={{ padding: '9px' }}
                withTime
                onClick={e =>
                  typeof e.stopPropagation === 'function' && e.stopPropagation()
                }
              />
            </Label>
          </>
        )}
        {!date_end && isOpen && (
          <div>
            <Link
                onClick={onClickNullEndDate}
                color={colors.bluelighter2}
                style={{ fontStyle: 'italic' }}
            >
              {t('date-end-add')}
            </Link>
          </div>
        )}
        <Padding
          top
          size="xs"
          style={{ color: hasWrongChainAssigned ? colors.redlight : undefined }}
          title={hasWrongChainAssigned ? t('playlist-wrong-chain') : undefined}
        >
          {t("Chain")}: {selectedChain?.name}
        </Padding>
        <div>
            {t('slug')}: {slug}
        </div>
        <div
          style={{
            display: 'inline-block',
            textAlign: 'right',
            marginTop: '25px',
          }}
        >
          <Button
            icon="save"
            iconSize="lg"
            onClick={onClickSubmit}
            theme="secondary"
            radius={5}
            size="xs"
            padding="6px"
          >
            {t('Save')}
          </Button>
        </div>
      </div>
    );
}

PlaylistsForm.propTypes = {
    errors: PropTypes.shape({
        name: PropTypes.string,
        date_start: PropTypes.string,
        date_end: PropTypes.string,
    }),
    isOpen: PropTypes.bool,
    values: PropTypes.shape(layerFormProps),
    onChangeForm: PropTypes.shape({
        name: PropTypes.func,
        date_start: PropTypes.func,
        date_end: PropTypes.func,
    }),
    onClickNullStartDate: PropTypes.func.isRequired,
    onClickNullEndDate: PropTypes.func.isRequired,
    onClickRemoveStartDate: PropTypes.func.isRequired,
    onClickRemoveEndDate: PropTypes.func.isRequired,
    onClickSubmit: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
};

PlaylistsForm.defaultProps = {
    errors: {
        name: null,
        date_start: null,
        date_end: null,
    },
    isOpen: false,
    values: {},
    onChangeForm: {
        name: () => null,
        date_start: () => null,
        date_end: () => null,
    },
};

export default PlaylistsForm
